export const HOME_PATH = '/';
export const HOME_ID_PATH = '/:id'
export const VIDEO_SHORT_PATH = 'Video-kurz';
export const VIDEO_LONG_PATH = 'Video';
export const HOME_VIDEO_PATH = HOME_ID_PATH + '/:video';
